import client from '../client/client'

const getIconsRequest = () => client.get('/api/v1/admin/icons')

const addIconsRequest = (data: any) => client.post(`/api/v1/admin/icons`, data)

const deleteIconsRequest = (id: number) => client.delete(`/api/v1/admin/icons/${id}`)

export {getIconsRequest, addIconsRequest, deleteIconsRequest}
